import { Box, Icon, Link } from '@nimbus-ds/components';
import { ChevronRightIcon } from '@nimbus-ds/icons';
import { PlanRecommendationResponse } from '@tiendanube/common';
import useTranslationPreOnboarding from 'domains/PreOnboarding/useTranslationPreOnboarding';
import { PlanPageBodyProps } from '../../types';
import { PlanCard } from '../PlanCard';

export function PlanPageBodyDesktop({
  plans,
  onPlanSelect,
}: Readonly<PlanPageBodyProps>) {
  const t = useTranslationPreOnboarding('recommendPlan');

  const allPlansOnClik = async () => onPlanSelect('none');

  return (
    <>
      <Box mt="4" display="flex" gap="4">
        {Object.entries(plans).map(
          ([planType, plan]: [string, PlanRecommendationResponse]) => (
            <PlanCard
              key={planType}
              type={planType}
              title={plan.title}
              price={plan.price}
              description={plan.description}
              features={plan.features}
              buttonText={t(`buttonCta.${planType}`)}
              recommended={planType === 'upgrade'}
              onButtonClick={onPlanSelect}
              showPaymentDisclaimer={planType === 'upgrade'}
            />
          ),
        )}
      </Box>
      <Box display="flex" justifyContent="center">
        <Link
          appearance="primary"
          as="button"
          onClick={allPlansOnClik}
          textDecoration="none"
        >
          <Icon source={<ChevronRightIcon />} color="currentColor" />
          {t('allPlans')}
        </Link>
      </Box>
    </>
  );
}
